import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from '../../admin/app';
import DefaultResolver from '../../common/resolvers/DefaultResolver';
/**
 * A custom route resolver for ExtensionPage that generates handles routes
 * to default extension pages or a page provided by an extension.
 */
export default class ExtensionPageResolver extends DefaultResolver {
  onmatch(args, requestedPath, route) {
    const extensionPage = app.registry.getPage(args.id);
    if (extensionPage) {
      return Promise.resolve(extensionPage);
    }
    return super.onmatch(args, requestedPath, route);
  }
}
_defineProperty(ExtensionPageResolver, "extension", null);
flarum.reg.add('core', 'admin/resolvers/ExtensionPageResolver', ExtensionPageResolver);